import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CoreModule } from "@webapp/core/core.module";
import { FormsModule } from "@angular/forms";
import { UiModule } from "@webapp/ui/ui.module";
import { QuillModule } from "ngx-quill";
import { SearchServiceProvider } from "@webapp/ui/providers/search.provider";
import { richTextEditorDeclarations, richTextEditorExports } from "@webapp/shared/rich-text-editor/index";
import { MarkedJsService } from "@webapp/shared/rich-text-editor/marked-js/marked-js.service";

@NgModule({
  imports: [CoreModule, CommonModule, FormsModule, UiModule, QuillModule.forRoot()],
  declarations: [...richTextEditorDeclarations],
  exports: [...richTextEditorExports],
  providers: [MarkedJsService, SearchServiceProvider],
})
export class RichTextEditorModule {}
